// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2ncss","colMin":"styles_colMin__3Z2Fd","colCheckbox":"styles_colCheckbox__1jEHR"};